module.exports = __webpack_public_path__ + "static/media/make-your-own-handwritten-white.b055a318.png";